import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { CouncilStatsService, CouncilStats } from '../shared/council-stats.service';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource, MatLegacyTable as MatTable } from '@angular/material/legacy-table';
import { DocumentData } from '@angular/fire/compat/firestore';
import { CouncilService } from '../shared/council.service';
import { Subscription } from 'rxjs';
import { ProgramGroupService } from '../shared/program-group.service';

@Component({
  selector: 'app-state-summary',
  templateUrl: './state-summary.component.html',
  styleUrls: ['./state-summary.component.css']
})
export class StateSummaryComponent implements OnInit, OnDestroy {

  councilGradingStats;
  totalCouncils;
  numParticipatingCouncils;
  councilParticipationPercentage;
  datasource;
  displayedColumns = ['councilId', 'diocese', 'division', 'faithTotal', 'familyTotal',
                      'communityTotal', 'lifeTotal', 'membershipTotal', 'councilTotal'];

  // this was annoying... finally found this after looking here:
  // https://stackoverflow.com/questions/51080143/angular-5-material-data-table-sorting-not-working
  sort;
  @ViewChild(MatSort) set content(content: ElementRef) {
    this.sort = content;
    if (this.sort) {
       this.datasource.sort = this.sort;
    }
  }
  @ViewChild(MatTable) table: MatTable<any>;

  private subscriptions = new Subscription();

  constructor(private councilStatsService: CouncilStatsService,
              private councilService: CouncilService,
              private programGroupService: ProgramGroupService) { }

  ngOnInit() {
    this.totalCouncils = this.councilService.getCouncils().length;

    const stats = this.councilStatsService.getAllCouncilGradingStats();
    this.subscriptions.add(stats.subscribe(res => {
      this.councilGradingStats = res.map(a => {
        const councilId = a.payload.doc.id;
        const council = this.councilService.getCouncilById(+councilId);
        if(council) {
          const councilStat: CouncilStats = {
            councilId: a.payload.doc.id,
            diocese: this.councilService.getDioceseById(+council.diocese),
            division: council.division,
            faithTotal: this.programGroupService.getProgramGroupTotal('faith', a.payload.doc),
            familyTotal: this.programGroupService.getProgramGroupTotal('family', a.payload.doc),
            communityTotal: this.programGroupService.getProgramGroupTotal('community', a.payload.doc),
            lifeTotal: this.programGroupService.getProgramGroupTotal('life', a.payload.doc),
            membershipTotal: this.programGroupService.getProgramGroupTotal('membership', a.payload.doc),
            councilTotal: this.getCouncilTotal(a.payload.doc)
          };

          return councilStat;
        } else {
          return null;
        }
      }).filter(stat => stat !== null);

      this.datasource = new MatTableDataSource(this.councilGradingStats);
      this.numParticipatingCouncils = this.councilGradingStats.length;
      this.councilParticipationPercentage = this.numParticipatingCouncils / this.totalCouncils;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getCouncilTotal(councilGradingStatDoc: DocumentData) {
    return this.programGroupService.getProgramGroupTotal('faith', councilGradingStatDoc) +
           this.programGroupService.getProgramGroupTotal('family', councilGradingStatDoc) +
           this.programGroupService.getProgramGroupTotal('community', councilGradingStatDoc) +
           this.programGroupService.getProgramGroupTotal('life', councilGradingStatDoc) +
           this.programGroupService.getProgramGroupTotal('membership', councilGradingStatDoc);
  }
}
